export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-bold font-heading text-primary-500 whitespace-nowrap">
              6080影视
            </span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              电视剧全集免费高清在线观看平台
              <br />
              海量资源 · 每日更新 · 流畅播放
              <br />
              超清画质 · 无需会员 · 完全免费
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-3 whitespace-nowrap">
              快速导航
            </h3>
            <ul className="space-y-2">
              {[
                { label: "每日更新", href: "#updates" },
                { label: "精选剧集", href: "#cards" },
                { label: "热门榜单", href: "#ranking" },
                { label: "手机看剧", href: "#app" },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.href);
                    }}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-3 whitespace-nowrap">
              热门分类
            </h3>
            <ul className="space-y-2">
              {[
                { label: "国产古装剧", href: "#index" },
                { label: "悬疑探案剧", href: "#index" },
                { label: "韩剧专区", href: "#index" },
                { label: "经典老剧", href: "#index" },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.href);
                    }}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-3 whitespace-nowrap">
              帮助中心
            </h3>
            <ul className="space-y-2">
              {[
                { label: "常见问答", href: "#faq" },
                { label: "联系我们", href: "#contact" },
                { label: "关于我们", href: "#about" },
                { label: "热门话题", href: "#topics" },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.href);
                    }}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/60 pt-8">
          <h3 className="text-sm font-semibold text-foreground-800 mb-4 whitespace-nowrap">
            合作伙伴
          </h3>
          <p className="text-sm text-foreground-500">虚位以待，诚邀优质伙伴入驻</p>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2018-2026 6080影视 · 电视剧全集免费高清在线观看 · 本站所有内容仅供交流学习
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("#faq");
              }}
              className="text-xs hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              使用协议
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("#faq");
              }}
              className="text-xs hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}